export default __webpack_public_path__ + "static/media/benefit-1.535face5.svg";